import { Component, ElementRef, HostListener, ViewChild, inject, input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Router, RouterModule } from '@angular/router'
import { CurrencyComponent } from '../currency/currency.component'
import { EventService } from 'src/app/core/services/event.service'
import { MatIconModule } from '@angular/material/icon'
import { scrollDetector } from 'src/app/core/utils/scroll-detector.util'
import { ButtonModule } from '../button/button.module'
import { IconButtonModule } from '../icon-button/icon-button.module'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { LanguageSelectComponent } from '../language-select/language-select.component'
import { EMPTY_MEDIA_DATA, ImageSizes } from 'src/app/core/interfaces/media-library.interface'
import { StorageService } from 'src/app/core/services/storage.service'
import { GlobalDataService } from 'src/app/core/services/global-data.service'
import { IHeaderMenuItem, MAX_HEADER_MENU_ITEMS } from 'src/app/core/interfaces/header.interface'
import { I18nService } from 'src/app/core/services/i18n.service'
import { defaultHeaderMenuItems, headerMenuEquipmentLink } from 'src/app/core/data/header-menu.data'
import { TrackingService, UserEvent } from 'src/app/core/services/tracking.service'


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    CurrencyComponent,
    LanguageSelectComponent,
    MatIconModule,
    ButtonModule,
    IconButtonModule,
  ],
})

export class HeaderComponent {
  private _trackingService = inject(TrackingService)
  protected eventService = inject(EventService)
  protected storageService = inject(StorageService)
  protected globalDataService = inject(GlobalDataService)
  protected i18n = inject(I18nService)

  @ViewChild('menuWrapper') menuWrapper!: ElementRef

  styles = input<any>({})
  logoSrc = input(EMPTY_MEDIA_DATA)
  logoDisplay = input(false)
  logoRedirect = input('')
  menuItems = input(defaultHeaderMenuItems, {
    transform: (items: IHeaderMenuItem[]) => {
      // can only have MAX_HEADER_MENU_ITEMS items
      items = items.slice(0, MAX_HEADER_MENU_ITEMS)

      // must have at least 1 equipment link
      const equipmentLink = items.find(
        item => item.type === 'internal'
        && item.routerLink === RoutePaths.Search
      )
      if (!equipmentLink) {
        if (items.length >= MAX_HEADER_MENU_ITEMS) {
          // menu items are full but still need the equipment link
          items[MAX_HEADER_MENU_ITEMS - 1] = headerMenuEquipmentLink
        } else {
          items.push(headerMenuEquipmentLink)
        }
      }
      return items
    }
  })

  RoutePaths = RoutePaths
  isSticky: boolean = false
  isStuck: boolean = false
  isScrolling: boolean = false
  navMenuIsOpen = false
  ImageSizes = ImageSizes

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.isStuck = scrollDetector()
  }

  toggleNavMenu() {
    this.navMenuIsOpen = !this.navMenuIsOpen
    this.eventService.notify('navMenuClicked', this.navMenuIsOpen)
  }

  closeNavMenu() {
    this.navMenuIsOpen = false
  }

  loadAndFocusSearch() {
    this.storageService.setItem('focusSearchOnLoad', 'true', 'session')
  }

  trackSearchClick() {
    this._trackingService.trackEvent(UserEvent.SearchIconClicked)
  }

  trackMenuClick(item: IHeaderMenuItem) {
    this._trackingService.trackEvent(UserEvent.HeaderMenuClicked, {
      label: this.i18n.get(item.label),
      type: item.type,
      routerLink: item.routerLink,
      href: item.href,
    })
  }

  getExternalLinkTarget(): string {
    if (window.parent !== window) {
      return '_parent'
    }
    return '_blank'
  }

  checkIncludeLanguageSelect(): boolean {
    return this.globalDataService.loadedLanguages() && this.globalDataService.loadedLanguages().length > 1
  }

  onContactClick($event: Event, item: IHeaderMenuItem) {
    $event.preventDefault()
    this.closeNavMenu()
    this.eventService.notify('contactClicked')
    this.trackMenuClick(item)
  }

  onInternalLinkClick(item: IHeaderMenuItem) {
    this.closeNavMenu()
    this.trackMenuClick(item)
  }

  onExternalLinkClick(item: IHeaderMenuItem) {
    this.closeNavMenu()
    this.trackMenuClick(item)
  }

  onSearchButtonClick() {
    this.loadAndFocusSearch()
    this.trackSearchClick()
  }
}
